import { ApplicationPropertyServiceData, ApplicationServiceData } from 'services/GameHosting/Application/applicationServiceType';
import { ApplicationBuildServiceData } from 'services/GameHosting/ApplicationBuild/applicationBuildServiceType';
import { PropertyType, StopMethods } from 'types/GameHosting/application';
import { FetchAction, ResetReducerAction } from 'types/services/redux-action';
import { FetchReducer } from 'types/services/redux-state';

export const FETCH_APPLICATIONS = 'FETCH_APPLICATIONS';

export const FETCH_APPLICATIONS_IS_PENDING = 'FETCH_APPLICATIONS_IS_PENDING';

export const FETCH_APPLICATIONS_IS_ERROR = 'FETCH_APPLICATIONS_IS_ERROR';

export const FETCH_APPLICATION_BY_ID = 'FETCH_APPLICATION_BY_ID';

export const FETCH_APPLICATION_BY_ID_IS_PENDING = 'FETCH_APPLICATION_BY_ID_IS_PENDING';

export const FETCH_APPLICATION_BY_ID_IS_ERROR = 'FETCH_APPLICATION_BY_ID_IS_ERROR';

export const CREATE_APPLICATION = 'CREATE_APPLICATION';

export const CREATE_APPLICATION_IS_PENDING = 'CREATE_APPLICATION_IS_PENDING';

export const CREATE_APPLICATION_IS_ERROR = 'CREATE_APPLICATION_IS_ERROR';

export const UPDATE_APPLICATION = 'UPDATE_APPLICATION';

export const UPDATE_APPLICATION_IS_PENDING = 'UPDATE_APPLICATION_IS_PENDING';

export const UPDATE_APPLICATION_IS_ERROR = 'UPDATE_APPLICATION_IS_ERROR';

export const CREATE_PROPERTY = 'CREATE_PROPERTY';

export const CREATE_PROPERTY_IS_PENDING = 'CREATE_PROPERTY_IS_PENDING';

export const CREATE_PROPERTY_IS_ERROR = 'CREATE_PROPERTY_IS_ERROR';

export const FETCH_PROPERTY = 'FETCH_PROPERTY';

export const FETCH_PROPERTY_IS_PENDING = 'FETCH_PROPERTY_IS_PENDING';

export const FETCH_PROPERTY_IS_ERROR = 'FETCH_PROPERTY_IS_ERROR';

export const UPDATE_PROPERTY = 'UPDATE_PROPERTY';

export const UPDATE_PROPERTY_IS_PENDING = 'UPDATE_PROPERTY_IS_PENDING';

export const UPDATE_PROPERTY_IS_ERROR = 'UPDATE_PROPERTY_IS_ERROR';

export const DELETE_PROPERTY = 'DELETE_PROPERTY';

export const DELETE_PROPERTY_IS_PENDING = 'DELETE_PROPERTY_IS_PENDING';

export const DELETE_PROPERTY_IS_ERROR = 'DELETE_PROPERTY_IS_ERROR';

export const DELETE_APPLICATION = 'DELETE_APPLICATION';

export const DELETE_APPLICATION_IS_PENDING = 'DELETE_APPLICATION_IS_PENDING';

export const DELETE_APPLICATION_IS_ERROR = 'DELETE_APPLICATION_IS_ERROR';

export const FETCH_APPLICATION_BUILD_APPLICATION = 'FETCH_APPLICATION_BUILD_APPLICATION';

export const FETCH_APPLICATION_BUILD_APPLICATION_IS_PENDING = 'FETCH_APPLICATION_BUILD_APPLICATION_IS_PENDING';

export const FETCH_APPLICATION_BUILD_APPLICATION_IS_ERROR = 'FETCH_APPLICATION_BUILD_APPLICATION_IS_ERROR';

export const FETCH_APPLICATION_BUILD_APPLICATION_IN_USE = 'FETCH_APPLICATION_BUILD_APPLICATION_IN_USE';

export const FETCH_APPLICATION_BUILD_APPLICATION_IN_USE_IS_PENDING = 'FETCH_APPLICATION_BUILD_APPLICATION_IN_USE_PENDING';

export const FETCH_APPLICATION_BUILD_APPLICATION_IN_USE_IS_ERROR = 'FETCH_APPLICATION_BUILD_APPLICATION_IN_USE_IS_ERROR';

export const FETCH_APPLICATION_TYPE = 'FETCH_APPLICATION_TYPE';

export const FETCH_APPLICATION_TYPE_IS_PENDING = 'FETCH_APPLICATION_TYPE_IS_PENDING';

export const FETCH_APPLICATION_TYPE_IS_ERROR = 'FETCH_APPLICATION_TYPE_IS_ERROR';

export const FETCH_STOP_METHOD = 'FETCH_STOP_METHOD';

export const FETCH_STOP_METHOD_IS_PENDING = 'FETCH_STOP_METHOD_IS_PENDING';

export const FETCH_STOP_METHOD_IS_ERROR = 'FETCH_STOP_METHOD_IS_ERROR';

export const CLEAN_ERROR = 'CLEAN_ERROR';

export const SORT_APPLICATIONS = 'SORT_APPLICATIONS';

export type ApplicationReducerState = {
  application: ApplicationServiceData | undefined;
  applications: ApplicationServiceData[] | undefined;
  applicationTypes: PropertyType[] | undefined;
  properties: ApplicationPropertyServiceData[] | undefined;
  stopMethod: StopMethods[];
  applicationBuild: ApplicationBuildServiceData[];
} & FetchReducer<
  | 'fetchApplicationBuildByApplication'
  | 'fetchApplications'
  | 'fetchApplicationById'
  | 'fetchApplicationType'
  | 'fetchStopMethod'
  | 'fetchProperties'
  | 'createApplication'
  | 'updateApplication'
  | 'deleteProperty'
  | 'createProperty'
  | 'updateProperty'
>;

export type ApplicationActions =
  | FetchAction<'FETCH_APPLICATION_BY_ID', ApplicationServiceData>
  | FetchAction<'FETCH_APPLICATION_BUILD_APPLICATION', ApplicationBuildServiceData>
  | FetchAction<'FETCH_STOP_METHOD', StopMethods[]>
  | { type: 'RESET_APPLICATION_REDUCER' }
  | ResetReducerAction;
